import { createContext, FC, useContext } from 'react';
import { SurveyDrawerController, useSurveyDrawerController } from '@components/SurveyDrawer/useSurveyDrawerController';

const SurveyDrawerContext = createContext<SurveyDrawerController | undefined>(undefined);

interface SurveyDrawerProviderProps extends React.PropsWithChildren {
  groupId: number;
}

export const SurveyDrawerContextProvider: FC<SurveyDrawerProviderProps> = ({ groupId, children }) => {
  const controller = useSurveyDrawerController(groupId); // or pass groupId as prop
  return <SurveyDrawerContext.Provider value={controller}>{children}</SurveyDrawerContext.Provider>;
};

export const useSurveyDrawerControllerContext = () => {
  const ctx = useContext(SurveyDrawerContext);
  if (!ctx) throw new Error('useSurveyDrawerControllerContext must be used within SurveyDrawerContextProvider');
  return ctx;
};
